module.exports = __webpack_public_path__ + "img/cdbl-popup.44ee9c6d.jpg";